// @ts-nocheck
import {Column} from 'react-table'
import {ReservationCustomHeader} from './ReservationCustomHeader'
import {Reservation} from '../../core/_models'
import { ReservationInfoCell } from '../../../../../../_dashboard/partials/components/commonColumns/ReservationCell'
import { ReservationActionsCell } from './ReservationActionsCell'
import { useIntl } from 'react-intl'; 

const reservationsColumns: ReadonlyArray<Column<Reservation>> = [
  // {
  //   Header: (props) => (
  //     <ReservationCustomHeader
  //       tableProps={props}
  //       title={useIntl().formatMessage({ id: 'COLUMNS.ID' })}
  //       className='min-w-125px'
  //     />
  //   ),
  //   accessor: 'hotel.hotel_id',
  // },
  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.HOTEL_NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'hotel.name',
    Cell: ({...props}) => <ReservationInfoCell reservation={props.data[props.row.index]} />,
  },
  

 

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.PAYMENT_METHOD' })}
        className='min-w-125px'
      />
    ),
    id: 'paymentMethod',
    Cell: ({ row }: { row: any }) => {
      const pm = row.original?.paymentMethod
      const val = pm?.translations?.[0]?.name || pm?.name || pm?.description || pm?.code || '-'
      return <span>{val}</span>
    },
  },
  
  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.STATUS' })}
        className='min-w-125px'
      />
    ),
    accessor: 'status',
    Cell: ({ value }: { value: { code: number; name: string; color: string } | null }) => {
      // Add null checking to prevent "Cannot read properties of null (reading 'color')" error
      if (!value) {
        return <span className="badge badge-light-secondary">-</span>;
      }
      
      return (
        <span
          className="badge fw-bold fs-8 px-3 py-2"
          style={{
            backgroundColor: value.color || '#6c757d',
            color: '#fff',
            borderRadius: '6px',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            minWidth: 'fit-content',
            textAlign: 'center',
            lineHeight: '1.2',
          }}
        >
          {value.name}
        </span>
      );
    },
  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.TOTAL_PRICE' })}
        className='min-w-125px'
      />
    ),
    accessor: 'totalPrice',
  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CHECK_IN_DATE' })}
        className='min-w-125px'
      />
    ),
    accessor: 'checkInDate',
    Cell: ({ value }: { value: string }) => (
      <span className="text-muted">{new Date(value)?.toLocaleString()}</span>
    ),

  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CREATED_AT' })}
        className='min-w-125px'
      />
    ),
    accessor: 'createdAt',
    Cell: ({ value }: { value: string }) => (
      <span className="text-muted">{new Date(value)?.toLocaleString()}</span>
    ),

  },


  {
   
    id: 'actions',
    Cell: ({...props}) => {
      const item = props.data[props.row.index]
      return <ReservationActionsCell id={item?._id} reservation={item} />
    },
  },

]

export {reservationsColumns}
